export default "__VITE_ASSET__CSuXkLG3__"